// extracted by mini-css-extract-plugin
export default {"customTooltip":"CustomTooltip_customTooltip__fsovd","arrow":"CustomTooltip_arrow__gUmSt","customTooltipDark":"CustomTooltip_customTooltipDark__uVMyb"};